import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	hiddenInForgeDisplayConditionsStrict: {
		id: 'project-settings-apps-issue-type-page-product-features.ecosystem.restricted-forge-field-warnings.hidden-in-forge-display-conditions-strict',
		defaultMessage:
			'This field isn’t visible because "{appName}" hid it. Go to the app’s configuration to change this.',
		description:
			'Warning text which appears when forge field is expanded and the field is hidden in configuration due to display conditions of the app',
	},
	hiddenInForgeDisplayConditionsWithIssueTypes: {
		id: 'project-settings-apps-issue-type-page-product-features.ecosystem.restricted-forge-field-warnings.hidden-in-forge-display-conditions-with-issue-types',
		defaultMessage:
			'This field isn’t visible on issue {issueTypesCount, plural, one {type} other {types}}: {issueTypes} because "{appName}" hid it. Go to the app’s configuration to change this.',
		description:
			'Warning text which appears when forge field is expanded and the field is hidden in configuration for some of the issue types due to display conditions of the app',
	},
	hiddenInForgeDisplayConditions: {
		id: 'project-settings-apps-issue-type-page-product-features.ecosystem.restricted-forge-field-warnings.hidden-in-forge-display-conditions',
		defaultMessage:
			'This field may be hidden by "{appName}". Check the app’s configuration to learn more.',
		description:
			'Warning text which appears when forge field is expanded and the field may be hidden in configuration for some of the issue types due to display conditions of the app',
	},
	hiddenInAccessNarrowing: {
		id: 'project-settings-apps-issue-type-page-product-features.ecosystem.restricted-forge-field-warnings.hidden-in-access-narrowing',
		defaultMessage:
			'This field belongs to an app "{appName}" that is blocked by your organization admin in this project through a data security policy.',
		description:
			'Warning text which appears when a field from an ecosystem app is expanded and the field is hidden in configuration due to data classification policy',
	},
	restrictedEcosystemAppFieldIconLabel: {
		id: 'project-settings-apps-issue-type-page-product-features.ecosystem.restricted-forge-field-warnings.restricted-ecosystem-app-field-icon-label',
		defaultMessage: 'This app field is restricted',
		description: 'Icon text indicating that the app field is restricted',
	},
	hiddenInForgeDisplayConditionsWithIssueTypesIssueTermRefresh: {
		id: 'project-settings-apps-issue-type-page-product-features.ecosystem.restricted-forge-field-warnings.hidden-in-forge-display-conditions-with-issue-types-issue-term-refresh',
		defaultMessage:
			'This field isn’t visible on work {issueTypesCount, plural, one {type} other {types}}: {issueTypes} because "{appName}" hid it. Go to the app’s configuration to change this.',
		description:
			'Warning text which appears when forge field is expanded and the field is hidden in configuration for some of the issue types due to display conditions of the app',
	},
});
